import React from 'react'
import { IndicatorCategoryData, IndicatorCardData } from './indicators.data'
import './IndicatorsColumn.scss'

interface IndicatorCardProps {
  card: IndicatorCardData
}

const IndicatorCard: React.FC<IndicatorCardProps> = ({ card }) => {
  // Parse title to separate main title from subtitle
  const titleMatch = card.title.match(/^(.+?)\s*\((.*?)\)$/)
  const mainTitle = titleMatch ? titleMatch[1].trim() : card.title
  const subtitle = titleMatch ? `(${titleMatch[2]})` : ''
  
  // Split "Tempo médio de atendimento" or "Tempo médio de espera" into two lines
  const isTempoMedio = mainTitle.includes('Tempo médio de atendimento') || mainTitle.includes('Tempo médio de espera')
  const titleParts = isTempoMedio 
    ? mainTitle.split(' de ')
    : [mainTitle]
  const titleLine1 = isTempoMedio ? titleParts[0] + ' de' : titleParts[0]
  const titleLine2 = isTempoMedio ? titleParts[1] : null
  
  // Determine if it's "On-line", "Em atendimento", "Taxa de sucesso", clock, video, or users icons for color
  const isOnline = card.title.includes('On-line')
  const isEmAtendimento = card.title.includes('Em atendimento')
  const isTaxaSucesso = card.title.includes('Taxa de sucesso')
  const isClock = card.icon.includes('fa-clock')
  const isVideo = card.icon.includes('fa-video')
  const isUsers = card.icon.includes('fa-users')
  
  return (
    <div className="indicator-column-card">
      <div className="indicator-column-card__header">
        <div className={`indicator-column-card__icon ${
          isOnline ? 'indicator-column-card__icon--online' : 
          isEmAtendimento ? 'indicator-column-card__icon--atendimento' : 
          isTaxaSucesso ? 'indicator-column-card__icon--taxa-sucesso' :
          isClock ? 'indicator-column-card__icon--clock' :
          isVideo ? 'indicator-column-card__icon--video' :
          isUsers ? 'indicator-column-card__icon--users' :
          `indicator-column-card__icon--${card.iconColor}`
        }`}>
          <i className={card.icon}></i>
        </div>
        <div className="indicator-column-card__title-wrapper">
          <p className="indicator-column-card__title">{titleLine1}</p>
          {titleLine2 && <p className="indicator-column-card__title indicator-column-card__title--line2">{titleLine2}</p>}
          {subtitle && <p className="indicator-column-card__subtitle">{subtitle}</p>}
        </div>
      </div>
      <div className="indicator-column-card__content">
        <h3 className="indicator-column-card__value">{card.value}</h3>
        <p className="indicator-column-card__description">{card.description}</p>
      </div>
    </div>
  )
}

interface IndicatorsColumnProps {
  category: IndicatorCategoryData
}

export const IndicatorsColumn: React.FC<IndicatorsColumnProps> = ({ category }) => {
  return (
    <div className="indicators-column">
      <div className="indicators-column__header">
        <h3 className="indicators-column__title">{category.title}</h3>
        {category.filters && (
          <div className="indicators-column__filters">
            {category.filters.options.map((option) => (
              <button
                key={option}
                className={`indicators-column-filter-btn ${
                  category.filters!.active === option ? 'active' : ''
                }`}
                onClick={() => category.filters!.onChange(option)}
              >
                {option}
              </button>
            ))}
          </div>
        )}
      </div>
      <div className="indicators-column__cards">
        {category.cards.map((card, index) => (
          <IndicatorCard key={index} card={card} />
        ))}
      </div>
    </div>
  )
}

